<template>
    <div class="card mb-25 border-0 bg-white add-user-card">
        <div class="card-header">
            <h3 class="text-black fw-semibold">Enregistrement du bon de commande fournisseur</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="addBon" :keep-values="valuess" :validation-schema="bonSchema">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Date Com Four. <span class="text-danger">*</span>
                                            </label>
                                            <Field name="dateOperation" v-model="dateOperation" type="datetime-local"
                                                :max="currentDateTime"
                                                class="form-control shadow-none fs-md-15 text-black"
                                                placeholder="Date oper." />
                                            <ErrorMessage name="dateOperation" class="text-danger" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Référence du document <span class="text-danger">*</span>
                                            </label>
                                            <Field name="refDoc" v-model="refDoc" type="text"
                                                class="form-control shadow-none fs-md-15 text-black"
                                                placeholder="Référence" />
                                            <ErrorMessage name="refDoc" class="text-danger" />
                                        </div>
                                    </div>

                                    <div class="col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Fournisseur <span class="text-danger">*</span>
                                            </label>
                                            <Multiselect :options="fournisseurOptions" :searchable="true"
                                                track-by="value" label="label" v-model="fournisseur"
                                                placeholder="Sélectionner le fournisseur"
                                                @update:model-value="(val) => { fournisseur = val; fournisseurError = ''; }" />
                                            <div class="text-danger mt-1" v-if="fournisseurError">{{ fournisseurError }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Montant total
                                            </label>
                                            <Field name="montantTotal" type="number"
                                                class="form-control shadow-none fs-md-15 text-black"
                                                placeholder="Montant total calculé" v-model="montantTotal" readonly />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Image du bon -->
                            <div class="col-md-2">
                                <label class="d-block text-black fw-semibold mb-1">
                                    Image du bon
                                </label>
                                <div class="upload-container">
                                    <input type="file" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                                        accept="image/jpeg, image/png, image/jpg" hidden />
                                    <div class="preview-card" @click="triggerFileInput">
                                        <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                                        <div v-else class="text-center">
                                            <div><i class="icofont icofont-camera fs-1"></i></div>
                                            Cliquez pour ajouter l'image du bon
                                        </div>
                                        <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage">
                                            <i class="icofont icofont-close"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 m-10">
                        <div class="row">
                            <div class="border border-primary mb-10">
                                <div
                                    class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                                    <div class="col-md-7">
                                        <h4 class="fs-4 text-white">Les produits</h4>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="d-flex float-end">
                                            <button class="btn btn-success" type="button" :disabled="isDisable"
                                                :class="{ 'cursor-not-allowed': isDisable }" @click="addRowProduit()">
                                                <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>
                                                Ajouter un produit
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row gx-2 mt-2 fw-semibold">
                                    <div class="col-md-4">Produit</div>
                                    <div class="col-md-2">Quantité</div>
                                    <div class="col-md-2">Prix Unitaire</div>
                                    <div class="col-md-2">Montant</div>
                                    <div class="col-md-2">Action</div>
                                </div>
                                <hr class="mt-1" />

                                <div class="row gx-2" v-for="(produit, produitIndex) in produits" :key="produitIndex">

                                    <div class="col-md-4 mb-2">
                                        <Multiselect v-model="produit.produit"
                                            :options="listeProduitDisponible(produitIndex)" :searchable="true"
                                            placeholder="Sélectionner un produit"
                                            @select="selectProd(produit.produit, produit)" :class="validateRowProduit(produit.produit)
                                                ? 'fs-md-15 text-black is-invalid'
                                                : 'fs-md-15 text-black'" />
                                        <div class="text-danger" v-if="validateRowProduit(produit.produit)">
                                            Le produit est obligatoire.
                                        </div>
                                    </div>

                                    <div class="col-md-2 mb-2">
                                        <div class="input-group">
                                            <input type="number" v-model="produit.qteBon"
                                                @input="calculMontant(produit)" :class="validateRowProduit(produit.qteBon)
                                                    ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                                    : 'form-control shadow-none fs-md-15 text-black'"
                                                placeholder="Quantité" />
                                            <span class="input-group-text">
                                                {{ produit.uniteMesure != null
                                                    ? produit.uniteMesure.replace("[", "").replace("]", "")
                                                    : 'UM' }}
                                            </span>
                                        </div>
                                        <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">
                                            La quantité est obligatoire.
                                        </div>
                                    </div>

                                    <div class="col-md-2 mb-2">
                                        <input type="number" v-model="produit.prix" @input="calculMontant(produit)"
                                            class="form-control shadow-none fs-md-15 text-black"
                                            placeholder="Prix unitaire" />
                                    </div>

                                    <div class="col-md-2 mb-2">
                                        <input type="number" v-model="produit.montant" readonly
                                            class="form-control shadow-none fs-md-15 text-black"
                                            placeholder="Montant" />
                                    </div>

                                    <div class="col-md-2 mb-2">
                                        <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                                            @click="removeRowProduit(produitIndex)">
                                            <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <div class="d-flex align-items-center">
                            <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isDisable">
                                Enregistrer le bon
                            </button>
                            <router-link to="/bons/liste-bonLivraison" class="btn btn-danger">
                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch, computed, nextTick } from 'vue';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
    name: "AddBonCommandeFournisseur",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },

    setup: () => {
        const router = useRouter();
        const route = useRoute();
        const { setFieldValue } = useForm();

        const bonSchema = Yup.object().shape({
            dateOperation: Yup.string().required('La date de l\'opération est obligatoire'),
            refDoc: Yup.string().required('La référence du document est obligatoire'),
            montantTotal: Yup.number().notRequired(),
        });

        const valuess = ref();
        const dateOperation = ref(getCurrentDateTime());
        const currentDateTime = ref(getCurrentDateTime());
        const refDoc = ref(null);
        const fournisseur = ref<number | null>(null);
        const fournisseurOptions = ref([]);
        const produitOptions = ref([]);
        const montantTotal = ref(0);
        const isDisable = ref(true);
        const submitButton = ref<HTMLButtonElement | null>(null);
        const fileInput = ref(null);
        const imagePreview = ref(null);
        const imageFile = ref<File>(null);
        const fournisseurError = ref('');

        const demandePrixId = ref<string | null>(null);
        const isFromDemandePrix = ref(false);

        const produits = reactive([
            {
                produit: '',
                qteBon: 0,
                prix: 0,
                montant: 0,
                nomProd: '',
                resteAliv: 0,
                uniteMesure: null,
            },
        ]);

        const calculMontant = (produit: any) => {
            if (produit.qteBon != null && produit.prix != null) {
                produit.montant = produit.qteBon * produit.prix;
            } else {
                produit.montant = 0;
            }
            totals();
        };

        const totals = () => {
            montantTotal.value = produits.reduce((acc, p) => acc + (parseFloat(p.montant as any) || 0), 0);
        };

        const addRowProduit = () => {
            produits.push({
                produit: '',
                qteBon: 0,
                prix: 0,
                montant: 0,
                nomProd: '',
                resteAliv: 0,
                uniteMesure: null,
            });
        };

        const removeRowProduit = (index: number) => {
            if (produits.length > 1) produits.splice(index, 1);
            totals();
        };

        const validateRowProduit = (e: any) => {
            return e === '' || e === 0 || e === '0' || e == null || e < 0;
        };

        const listeProduitDisponible = (currentIndex: number) => {
            const selectedIds = produits
                .filter((_, index) => index !== currentIndex && produit_value(_.produit))
                .map(p => produit_value(p.produit))
                .filter(id => id !== null);

            return produitOptions.value.filter(option => {
                const productId = option.value.split('|')[0];
                return !selectedIds.includes(productId);
            });
        };

        const produit_value = (val: string) => {
            if (!val) return null;
            return val.split('|')[0];
        };

        const selectProd = (selectedProduit: string, produit: any) => {
            const parts = selectedProduit.split('|');
            produit.nomProd = parts[1] + ' - ' + parts[2];
            produit.uniteMesure = parts[3];
            produit.prix = parseFloat(parts[4] || '0');
            produit.qteBon = produit.qteBon || 1;
            produit.montant = produit.qteBon * produit.prix;
            produit.resteAliv = 0;
            totals();
        };

        watch(produits, (newValue) => {
            isDisable.value = newValue.some(p =>
                p.qteBon < 1 ||
                p.produit === ''
            );
            totals();
        }, { deep: true });
        watch(fournisseur, (newVal) => {
            let finalValue: string | number | null = null;

            if (newVal == null) {
                finalValue = null;
            } else if (typeof newVal === 'object' && 'value' in (newVal as object)) {
                finalValue = (newVal as any).value ?? null;
            } else {
                finalValue = newVal;
            }

            setFieldValue('fournisseur', finalValue ? String(finalValue) : null);
            console.log("setFieldValue appelleeee", finalValue ? String(finalValue) : null);

            if (isFromDemandePrix.value) return;
            if (finalValue) fetchProduits(finalValue as number);
        }, { immediate: true });

        const fetchFournisseur = async () => {
            try {
                const response = await ApiService.get("all/fournisseurs");
                const fournisseurData = response.data.data.data;
                fournisseurOptions.value = fournisseurData.map((f: any) => {
                    if (f.statut === 2 || f.statut === "2") {
                        return { value: f.id, label: `${f.sigle} - ${f.denomination}` };
                    } else {
                        return {
                            value: f.id,
                            label: f.nomFournisseur && f.prenomFournisseur
                                ? `${f.nomFournisseur} ${f.prenomFournisseur}`
                                : `${f.denomination || f.nomFournisseur}`
                        };
                    }
                });
            } catch (err) {
                //
            }
        };

        const fetchProduits = async (fournisseurId?: number, demandePrixIdParam?: string) => {
            try {
                let endpoint = "/all/produitconditionnements";

                if (fournisseurId && demandePrixIdParam) {
                    endpoint = `/produitconditionnements/demandeprix/${demandePrixIdParam}/fournisseur/${fournisseurId}`;
                }

                const response = await ApiService.get(endpoint);
                const produitsData = response.data.data;

                if (!produitsData || !Array.isArray(produitsData)) {
                    produitOptions.value = [];
                    return;
                }

                produitOptions.value = produitsData.map((item: any) => {
                    let produitcondi, produit, conditionnement;

                    if (item.produitcondi) {
                        produitcondi = item.produitcondi;
                        produit = produitcondi.produit;
                        conditionnement = produitcondi.conditionnement;
                    } else {
                        produitcondi = item;
                        produit = item.produit;
                        conditionnement = item.conditionnement;
                    }

                    if (!produit || !conditionnement) return null;

                    return {
                        value: `${produitcondi.id}|${produit.codeProduit}|${produit.nomProd}|[${conditionnement.libelle}]|${produitcondi.prixVenteHt || 0}`,
                        label: `${produit.nomProd} [${conditionnement.libelle}] - ${produit.codeProduit}`,
                    };
                }).filter((opt: any) => opt !== null);

            } catch (err) {
                produitOptions.value = [];
            }
        };

        const fetchDemandePrix = async (demandePrixIdParam: string) => {
            try {
                const { data } = await ApiService.get(`/demandePrixs/${demandePrixIdParam}`);
                const demandePrix = data.data;

                const fournisseurId = demandePrix.fournisseur.id;
                const fournisseurOption = fournisseurOptions.value.find((f: any) => f.value === fournisseurId);

                if (!fournisseurOption) {
                    console.warn("Fournisseur non trouvé dans les options");
                    return;
                }

                fournisseur.value = fournisseurOption.value;;
                setFieldValue('fournisseur', fournisseurOption.value);

                await nextTick();
                setFieldValue('fournisseur', String(fournisseurOption.value));
                console.log("=== fournisseur setFieldValue ===", String(fournisseurOption.value));

                await fetchProduits(fournisseurId, demandePrixIdParam);

                produits.splice(0, produits.length);

                if (demandePrix.demandepriprocondis?.length > 0) {
                    demandePrix.demandepriprocondis.forEach((item: any) => {
                        const produitCondi = item.produitcondi;
                        const produit = produitCondi.produit;
                        const conditionnement = produitCondi.conditionnement;
                        const prix = parseFloat(item.prix || produitCondi.prixVenteHt || 0);
                        const qte = parseInt(item.qtite) || 1;

                        produits.push({
                            produit: `${produitCondi.id}|${produit.codeProduit}|${produit.nomProd}|[${conditionnement.libelle}]|${produitCondi.prixVenteHt || 0}`,
                            prix: prix,
                            qteBon: qte,
                            montant: qte * prix,
                            nomProd: produit.nomProd,
                            resteAliv: 0,
                            uniteMesure: `[${conditionnement.libelle}]`,
                        });
                    });
                } else {
                    produits.push({
                        produit: '', prix: 0, qteBon: 0, montant: 0,
                        nomProd: '', resteAliv: 0, uniteMesure: null,
                    });
                }

                totals();
                isDisable.value = produits.some(p => !p.produit || p.qteBon <= 0);

            } catch (err: any) {
                error(err.response?.data?.message || 'Erreur lors du chargement de la demande de prix');
            }
        };

        const addBon = async (values: any, { resetForm }: any) => {

            if (!fournisseur.value) {
                fournisseurError.value = 'Le fournisseur est obligatoire';
                return;
            }
            fournisseurError.value = '';

            values["fournisseur"] = fournisseur.value;
            if (submitButton.value) submitButton.value.disabled = true;

            if (imageFile.value) {
                values["imagePrincipal"] = imageFile.value;
            }

            values["produitcondibons"] = produits.map((produit) => ({
                produit: produit.produit.split("|")[0],
                qteBon: produit.qteBon,
                prix: produit.prix,
                montant: produit.montant,
                resteAliv: produit.resteAliv,
                uniteMesure: produit.uniteMesure,
                nomProd: produit.nomProd,
            }));

            values["montantTotal"] = montantTotal.value;

            try {
                await ApiService.postWithFile("/boncomfournisseurs", values);
                success("Le bon de commande enregistré avec succès");
                router.push({ name: "ListeBonCommandeFournisseur" });
            } catch (err) {
                if (submitButton.value) submitButton.value.disabled = false;
                error("Erreur lors de l'ajout du bon de commande");
            }
        };

        const triggerFileInput = () => fileInput.value.click();

        const onFilePrinChange = (event: any) => {
            const file = event.target.files[0];
            if (file) {
                imageFile.value = file;
                const reader = new FileReader();
                reader.onload = (e: any) => { imagePreview.value = e.target.result; };
                reader.readAsDataURL(file);
            }
        };

        const removeImage = () => {
            imagePreview.value = null;
            imageFile.value = null;
        };

        function getCurrentDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }

        onMounted(async () => {
            const demandePrixIdParam = route.query.demandePrixId as string;

            if (demandePrixIdParam) {
                demandePrixId.value = demandePrixIdParam;
                isFromDemandePrix.value = true;
                await fetchFournisseur();
                await fetchDemandePrix(demandePrixIdParam);
            } else {
                isFromDemandePrix.value = false;
                await Promise.all([
                    fetchFournisseur(),
                    fetchProduits(),
                ]);
            }

            currentDateTime.value = getCurrentDateTime();
        });

        return {
            bonSchema,
            valuess,
            dateOperation,
            currentDateTime,
            refDoc,
            fournisseur,
            fournisseurOptions,
            produitOptions,
            montantTotal,
            isDisable,
            submitButton,
            fileInput,
            imagePreview,
            imageFile,
            produits,
            demandePrixId,
            isFromDemandePrix,
            addBon,
            addRowProduit,
            removeRowProduit,
            validateRowProduit,
            listeProduitDisponible,
            selectProd,
            calculMontant,
            triggerFileInput,
            onFilePrinChange,
            removeImage,
            getCurrentDateTime,
            fournisseurError
        };
    },
});
</script>

<style scoped>
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.preview-card {
    width: 100%;
    height: 120px;
    border: 2px dashed #4caf50;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    background: #f8f8f8;
    position: relative;
}

.preview-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: red;
    color: white;
    border: none;
    padding: 5px 8px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
}

.delete-btn:hover {
    background: darkred;
}

.cursor-not-allowed {
    cursor: not-allowed;
}
</style>